import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function LatestArticles() {
    const [latestArticles, setLatestArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLatestArticles = async () => {
            try {
                const response = await fetch('/articles/index.json');
                if (!response.ok) {
                    throw new Error('Failed to fetch latest articles');
                }
                const data = await response.json();
                // Sort articles by date in descending order and get the latest 3
                const sortedArticles = data.articles.sort((a, b) => new Date(b.date) - new Date(a.date));
                setLatestArticles(sortedArticles.slice(0, 3));
            } catch (err) {
                setError(err.message);
                console.error('Error fetching latest articles:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchLatestArticles();
    }, []);

    if (loading) return <div className="latest-articles loading">Loading latest articles...</div>;
    if (error) return <div className="latest-articles error">Error loading latest articles</div>;
    if (!latestArticles.length) return null;

    return (
        <div className="latest-articles">
            <h2>Latest thoughts</h2>
            <div className="articles-grid">
                {latestArticles.map((articles) => (
                    <article key={articles.id} className="articles-item">
                        <Link to={`/blog/${articles.slug}`} className="read-more">
                            {articles.name}
                        </Link>
                        <span className="articles-date">{new Date(articles.date).toLocaleDateString()}</span>
                    </article>
                ))}
            </div>
        </div>
    );
}

export default LatestArticles; 